import { useQuery } from "react-query";
import ApiClient from "../../../common/API";
import { USE_QUERY_DEFAULT_OPTIONS } from "../../../Constants/settings";
import moment from "moment";
import { useMemo } from "react";

export const STORE_ZERO_SALES_TABLE = "l3_frg_sap_zero_sales";
export const STORE_ACTIVE_LISTING_TABLE = "l3_top888_and_4k_zero_sales";
export const STORE_INNOVATION_LISTING_TABLE = "l2_innovation_articles";


export function useStoreZeroSalesOverView({ params }) {
    const { store_id, days, startDate, endDate, article_category, article_sub_category, ...restParams } = params

    if (startDate && endDate) {
        restParams['transaction_date__gte'] = moment(startDate).format('YYYY-MM-DD');
        restParams['transaction_date__lte'] = moment(endDate).format('YYYY-MM-DD');
    }

    // TODO: for the meantime this API maintain 4 views due to can't handle HAVING clause in query
    const view_name = `zero_sales_overview_${days}_days`

    const { data: zeroSalesData, isLoading: isLoadingZeroSalesData } = useQuery(
        [STORE_ZERO_SALES_TABLE, "article_number", restParams, startDate, endDate,
        ],
        () => ApiClient().get(`data/table/${STORE_ZERO_SALES_TABLE}/query/`, {
            params: {
                ...restParams,
                view: view_name,
                limit: 1000
            }
        }).then(res => {
            return res.data.data

        }), {
        ...USE_QUERY_DEFAULT_OPTIONS,
        enabled: !!params.company_id && !!startDate && !!endDate // Only fetch when company_id and dates are available
    });
    return {
        zeroSalesData,
        isLoadingZeroSalesData,
    };
}

export function useStoresList() {
    const { data, isLoading } = useQuery(
        [STORE_ZERO_SALES_TABLE, 'stores', 'stores_list'],
        () => {


            return ApiClient().get(`data/table/${STORE_ZERO_SALES_TABLE}/query/`, {
                params: {
                    columns: "store_id,store_name,article_number",
                    group_by: "store_id,store_name,article_number",
                    limit: 1000
                },
            }).then((res) => res.data.data);
        },
        {
            ...USE_QUERY_DEFAULT_OPTIONS,
        }
    );

    return {
        data,
        isLoading,
    };
}

export function useAvailableDateRange() {
    return useQuery(
        [STORE_ZERO_SALES_TABLE, 'company_name', 'store_name'],
        () => ApiClient().get(`data/table/${STORE_ZERO_SALES_TABLE}/filter_values/`, {
            params: {
                columns: "transaction_date"
            }
        }).then(res => {
            return res.data.transaction_date
        }), {
        ...USE_QUERY_DEFAULT_OPTIONS
    }
    );
}

export function useZeroSalesData({ params }) {
    const { days, startDate, endDate, ...restParams } = params

    if (startDate && endDate) {
        restParams['transaction_date__gte'] = moment(startDate).format('YYYY-MM-DD');
        restParams['transaction_date__lte'] = moment(endDate).format('YYYY-MM-DD');
    }



    const { data: zeroSalesData, isLoading: isLoadingZeroSalesData } = useQuery(
        [STORE_ZERO_SALES_TABLE, "article_number", restParams, startDate, endDate],
        () => ApiClient().get(`data/table/${STORE_ZERO_SALES_TABLE}/query/`, {
            params: {
                ...restParams,
                view: "zero_sales",
                limit: 5000
            }
        }).then(res => {
            return res.data.data

        }), {
        ...USE_QUERY_DEFAULT_OPTIONS,
        enabled: !!params.company_id && !!startDate && !!endDate && !!params.store_id
    });

    return {
        zeroSalesData, //: latestZeroSalesData,
        isLoadingZeroSalesData,
    };
}



export function usePerStoreActiveSKUListing({ params }) {

    const article_type = params?.article_type;

    const { data: perStoreActiveListingRaw, isLoading: isLoadingPerStoreActiveListing } = useQuery(
        [STORE_ACTIVE_LISTING_TABLE, article_type, 'article_sub_category'],
        () => ApiClient().get(`data/table/${STORE_ACTIVE_LISTING_TABLE}/query/`, {
            params: {
                article_type,
                columns: "company_id,store_id,article_type,article_sub_category,end_date",
                group_by: "company_id,store_id,article_type,article_sub_category,end_date",
                aggregates: "article_code_count_distinct",
                limit: 10000
            }
        }).then(res => res.data.data),
        {
            ...USE_QUERY_DEFAULT_OPTIONS,
            enabled: !!params?.company_id // Only fetch when company_id is available
        }
    );

    // Filter out items with end_date !== null
    const perStoreActiveListing = useMemo(() => {
        if (!Array.isArray(perStoreActiveListingRaw)) return [];
        return perStoreActiveListingRaw.filter(item => item.end_date === null);
    }, [perStoreActiveListingRaw]);

    return {
        perStoreActiveListing,
        isLoadingPerStoreActiveListing,
    };
}

export function usePerStoreActiveSKUListingInnovation({ params } = {}) {

    const article_type = params?.article_type

    const {
        data: perStoreActiveListingInnovation,
        isLoading: isLoadingPerStoreActiveListingInnovation
    } = useQuery(
        [STORE_INNOVATION_LISTING_TABLE, article_type], 
        async () => {

            const res = await ApiClient().get(
                `data/table/${STORE_INNOVATION_LISTING_TABLE}/query/`,
                {
                    params: {
                        article_type,
                        columns: "store_id,article_type",
                        group_by: "store_id,article_type",
                        aggregates: "article_number_count_distinct",
                        limit: 5000
                    }
                }
            )
            return res.data.data
        },
        {
            ...USE_QUERY_DEFAULT_OPTIONS,
            enabled: !!article_type
        }
    )

    return {
        perStoreActiveListingInnovation,
        isLoadingPerStoreActiveListingInnovation,
    }
}